import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { CmsService } from "../../_services/cms.service";

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
declare const tinymce: any;

@Component({
  selector: 'app-add-cms',
  templateUrl: './add-cms.component.html',
  styleUrls: ['./add-cms.component.css']
})
export class AddCmsComponent implements OnInit {

  addCmsForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;
  selectedfile: Array<File> = [];
  imgtype = 'image/*';
  png = 'image/png';
  jpg = 'image/jpg';
  jpeg = 'image/jpeg';
  docid: string;
  urls = new Array<string>();

  confg = {
    height: 500,
    menubar: false,
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks code fullscreen',
      'insertdatetime media table paste code help wordcount',
      'image'
    ],
    toolbar:
      'undo redo | formatselect | bold italic backcolor | \
      alignleft aligncenter alignright alignjustify | \
      bullist numlist outdent indent | removeformat | image | help',
    /* enable title field in the Image dialog*/
    image_title: true,
    /* enable automatic uploads of images represented by blob or data URIs*/
    automatic_uploads: true,
    file_picker_types: 'image',
    /* and here's our custom image picker*/
    file_picker_callback: function (cb, value, meta) {
      var input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');

      /*
        Note: In modern browsers input[type="file"] is functional without
        even adding it to the DOM, but that might not be the case in some older
        or quirky browsers like IE, so you might want to add it to the DOM
        just in case, and visually hide it. And do not forget do remove it
        once you do not need it anymore.
      */

      input.onchange = function () {
        let file = (<HTMLInputElement>this).files[0];

        var reader = new FileReader();
        reader.onload = function () {
          /*
            Note: Now we need to register the blob in TinyMCEs image blob
            registry. In the next release this part hopefully won't be
            necessary, as we are looking to handle it internally.
          */
          var id = 'blobid' + (new Date()).getTime();
          var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
          var base64 =  (<string>reader.result).split(',')[1];
          var blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);
          console.log(blobInfo);

          /* call the callback and populate the Title field with the file name */
          //cb(blobInfo.blobUri(), { title: file.name });
          cb(blobInfo.blobUri(), { title: file.name });
        };
        reader.readAsDataURL(file);
      };

      input.click();
    }
  };

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private cmsservice: CmsService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
      this.authenicationService.logout();
      this.router.navigateByUrl('/login');
    }

    this.addCmsForm = this.formBuilder.group({
      page: ['', [Validators.required]],
      section: ['', [Validators.required]],
      title: ['', [Validators.required]],
      content: ['', [Validators.required]],
      images: [''],
      status: ['true', [Validators.required]],
    });



    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }


  get f() { return this.addCmsForm.controls; }

  fileUpload(event) {
    this.urls = [];
    this.selectedfile = event.target.files as Array<File>;
    for (let i = 0; i < this.selectedfile.length; i++) {
      if (this.selectedfile[i].type === this.jpg || this.selectedfile[i].type === this.png || this.selectedfile[i].type === this.jpeg) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.urls.push(e.target.result);
        };
        console.log(this.selectedfile[i]);
        console.log(this.urls);
        reader.readAsDataURL(this.selectedfile[i]);
      } else {
        this.addCmsForm.controls.images.reset();
        this.toaster.showError('File Type', 'Only Images are allowed');
        return false;
      }



    }
  }


  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    //console.log(this.addCmsForm.invalid);
    // stop here if form is invalid
    if (this.addCmsForm.invalid) {
      this.spinnerService.hide();
      return;
    }

    const addPayload = {
      page: this.addCmsForm.controls.page.value,
      section: this.addCmsForm.controls.section.value,
      title: this.addCmsForm.controls.title.value,
      content: this.addCmsForm.controls.content.value,
      status: this.addCmsForm.controls.status.value
    };

    // console.log('form data',addPayload);
    // return;

    const formdata = new FormData();

    formdata.append('page', addPayload.page);
    formdata.append('section', addPayload.section);
    formdata.append('title', addPayload.title);
    formdata.append('content', addPayload.content);
    formdata.append('status', addPayload.status);
    if (this.selectedfile) {
      const files: Array<File> = this.selectedfile;
      for (let i = 0; i < files.length; i++) {
        formdata.append('images', files[i], files[i].name);
      }
    }

    this.addCMS(formdata);

  }


  addCMS(payload) {
    this.cmsservice.addCmsContent(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.router.navigate(['/list-cms']);
          } else {
            this.toaster.showError('Add CMS', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Add CMS', error.error.ResponseMessage);
        });
  }

}
